require('common')
import { observer, Provider } from 'mobx-preact'
import Nprogress from 'nprogress'
import React, { Component } from 'react'
import { render } from 'react-dom'
import 'regenerator-runtime/runtime'
import Login from 'ui/Login'
import Regist from 'ui/Regist'
import Reset from 'ui/Reset'
import Signup from 'ui/Signup'
import { getSearch } from 'util'
import toast from 'util/toast'
import store from '../store'

let { user } = store

async function initUser() {
  let { user } = store
  let authenticated = await user.isAuthenticated()
  if (!authenticated) {
    await AV.User.logOut()
    return null
  }
  return await user.fetch()
}

@observer
class App extends Component {
  render() {
    let view
    if (store.step == 'signup') {
      view = <Signup />
    } else if (store.step == 'login') {
      view = <Login/>
    } else if (store.step == 'regist') {
      view = <Regist/>
    } else if (store.step == 'reset') {
      view = <Reset/>
    } else {
      view = <div>not found</div>
    }
    let {title} = store
    return (
      <Provider store={store}>
        <div class="login-image-top"></div>
        <div class="login-form w-form">
          <div class="algin-center contact">
            <h2 class="login-title">{title}</h2>
            <div class="headline-sign">
              <div class="line-features gray"></div>
              <div class="color-line"></div>
            </div>
            {view}
          </div>
        </div>
      </Provider>
    )
  }
}

function init() {
  render(<App />, document.querySelector('.login-center'))
}

if (!user) {
  init()
} else {
  Nprogress.start()
  initUser().then(() => {
    Nprogress.done()
    init()
  }, error => {
    Nprogress.done()
    toast(error)
  })
}

$(function () {
  let o = getSearch()
  if (o.signup || o.login) {
    $('#signup-btn').click()
  }
})
